import React from "react";

export const StaffIconSvg = ({ pathNames, color }) => {
  return (
    <div>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.333 17.5v-1.667A3.333 3.333 0 0 0 10 12.5H5a3.333 3.333 0 0 0-3.333 3.333V17.5M7.5 9.167a3.333 3.333 0 1 0 0-6.667 3.333 3.333 0 0 0 0 6.667M18.333 17.5v-1.667a3.334 3.334 0 0 0-2.5-3.225m-2.5-10a3.333 3.333 0 0 1 0 6.459"
          stroke={
            pathNames?.toLowerCase()?.includes("staff")
              ? "#ffffff"
              : color
              ? color
              : "#667085"
          }
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
